import MobileBackButton from "./MobileBackButton";
import React from "react";
import moment from "moment";

export default function HolidayListView({ holidays, loading, onBack }) {
  return (
    <section className="holiday-list-page" aria-labelledby="holiday-list-title">
      <div className="holiday-list-header">
        <MobileBackButton
          type="button"
          className="holiday-list-back-btn"
          onClick={onBack}
          aria-label="Go back"
         />
        <h1 className="holiday-list-title" id="holiday-list-title">
          Holiday List
        </h1>
      </div>

      {loading ? (
        <p className="holiday-list-message" role="status">Loading holidays...</p>
      ) : holidays.length === 0 ? (
        <p className="holiday-list-message" role="status">No holidays found</p>
      ) : (
        <ul className="holiday-list-cards" aria-label="Holidays">
          {holidays.map((holiday) => {
            const date = moment(holiday.holiday_date || "", moment.ISO_8601, true).locale("en");
            const validDate = date.isValid();
            const weekend = validDate && (date.day() === 0 || date.day() === 6);

            return (
              <li
                className={`holiday-list-card${weekend ? " holiday-list-card--weekend" : ""}`}
                key={holiday.id}
              >
                <time
                  className="holiday-list-date"
                  dateTime={validDate ? date.format("YYYY-MM-DD") : undefined}
                >
                  {validDate ? date.format("DD/MM/YY") : "—"}
                </time>
                <span className="holiday-list-name">{holiday.holiday_name}</span>
                <span className="holiday-list-weekday">
                  {validDate ? date.format("dddd") : "—"}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
